var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorse3Female(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 100,
    viewBox: "0 0 90 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8240_8382)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.5911 74.439C42.5911 74.439 43.9363 75.139 45.4066 75.0198C46.8769 74.9007 48.5819 74.3199 48.5819 74.3199C48.5819 74.3199 54.3068 64.2525 60.5948 58.1615C67.8369 51.1471 75.6109 49.0472 75.6109 49.0472L73.8434 40.6776C73.8434 40.6776 75.0791 44.2816 56.9659 49.211C46.9708 51.9364 38.6962 50.7003 34.4573 49.6727C25.4007 47.4835 19.0971 44.8177 15.6559 41.9584C15.2335 43.5817 14.8112 43.9093 14.4045 45.5475L13.5599 51.5641C9.53993 50.5663 28.4039 58.1615 30.7971 60.4847C37.2103 66.7247 42.6067 74.4241 42.6067 74.4241L42.5911 74.439Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.344 17.2964C23.344 17.2964 29.3425 14.7201 42.0593 14.169C54.7761 13.618 64.0048 15.8072 64.0048 15.8072C64.0078 13.7716 64.0096 12.6304 64.0126 10.5948C64.0126 10.5948 67.1018 3.6251 67.008 0.229603C66.9141 -3.18079 64.3019 -6.99329 64.0048 -11.2526C63.7232 -15.5118 64.0048 -23.6581 64.0048 -23.6581L60.1022 -24.4027C60.1022 -24.4027 57.2006 -12.2653 44.2804 -12.7269C31.3603 -13.1886 28.3258 -18.9967 27.7627 -24.3729L22.5696 -22.9581C22.5696 -22.9581 23.9461 -17.7308 22.3506 -12.0865C22.3506 -12.0865 19.582 -4.46155 19.5195 2.47838C19.4882 5.2335 21.1775 7.88437 21.6624 9.89487L23.344 13.5733V17.2964Z",
    fill: "#737373"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.114 99.9502C16.7979 89.6892 15.2024 82.7791 14.3891 76.4646C13.7165 71.2075 13.4975 67.0227 13.4193 65.2058C13.2003 59.9041 12.9657 55.1981 13.7321 49.1815C14.217 45.3988 14.9052 44.2669 15.484 42.0926C15.4996 39.2779 16.1722 37.2674 16.7353 35.9718C17.6113 33.9911 17.9398 29.6125 19.457 26.9765C20.1922 25.7106 21.2402 23.864 21.9284 21.645C23.3049 17.207 23.6959 13.484 21.6781 9.88001C21.4279 9.43323 20.8335 8.43543 20.3017 6.93128C19.9263 5.88881 19.6447 4.63783 19.457 2.82094C19.2614 1.03492 18.9968 -4.71383 17.8695 -5.78712C16.7422 -6.86041 16.9007 -9.12148 16.7353 -10.2549",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.2783 98.9373C42.7945 93.0101 43.9364 88.319 43.6861 81.4535C43.5922 79.0409 43.9207 77.1346 43.733 74.8561C44.1866 75.0646 43.5766 74.9157 44.5933 74.9752C45.6882 75.0348 46.3295 74.7965 46.7988 74.6178C46.8457 78.609 46.6737 80.8578 46.7519 84.8788C46.8301 89.5401 46.9239 94.1866 47.0334 98.8182",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5586 98.9372C71.2781 96.6586 72.2323 93.3971 73.1239 89.4208C74.9853 81.0214 75.3919 76.2111 75.783 69.3903C76.2053 61.9589 76.4243 58.2507 75.9863 53.6638C75.5327 48.8684 74.7506 45.1601 74.0311 41.3328C73.5462 38.7563 72.9362 36.2246 72.1072 34.6013C68.3688 27.2146 66.0462 25.6064 64.7948 18.7856C63.5042 14.3178 64.7948 8.36081 64.7948 8.36081C64.7948 8.36081 65.694 6.70756 66.4136 4.01201C66.9297 2.12066 67.0236 0.452687 66.9923 -0.798288C66.8515 -1.43867 66.7264 -2.49604 66.9923 -3.7619C67.3364 -5.40008 69.4873 -7.27637 68.7052 -10.9995",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4043 39.1595C43.4043 38.1165 43.9987 37.2821 44.7339 37.2821C45.469 37.2821 46.0634 38.1165 46.0634 39.1595",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6626 9.8949C21.6626 9.8949 22.8044 11.7416 26.5116 12.4117",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7949 8.36084C64.7949 8.36084 63.2308 12.65 57.5293 12.65",
    stroke: "#2E2E2E",
    strokeWidth: 0.29,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9995 28C2.60975 35.5 -1.34118 68.5 9.62891 79",
    stroke: "#2E2E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.6 6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.338 78.5803C87.0383 70.2905 88.0981 37.0717 76.2546 27.5678",
    stroke: "#2E2E2E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6.6 6.6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8240_8382"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorse3Female);
export default __webpack_public_path__ + "static/media/torse-3-female.84f1b769984d3a106fc3aab6ff39c426.svg";
export { ForwardRef as ReactComponent };